import { Outlet, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function MarketingLayout() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <header className="container flex items-center justify-between py-6">
        <Link to="/" className="font-display text-xl">
          {t('marketing.nav.brand')}
        </Link>
        <nav className="flex gap-6 text-sm">
          <Link to="/login" className="text-primary">
            {t('marketing.nav.signin')}
          </Link>
        </nav>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="container py-8 text-sm text-muted-foreground flex flex-wrap gap-x-3 gap-y-2">
        <span>{t('marketing.footer.copyright')}</span>
        <span aria-hidden="true">·</span>
        <Link to="/imprint">{t('marketing.footer.imprint')}</Link>
        <span aria-hidden="true">·</span>
        <Link to="/legal">{t('marketing.footer.privacy')}</Link>
      </footer>
    </div>
  );
}
